<template>
  <el-dialog title="配件查看" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height">
          <div class="table_main" style="height: 400px!important;">
            <el-row v-if="bom_change_edit">
              <el-col>
                <el-button type="primary" class="button-sty btn_zdy" style="margin: 0 !important;" @click="addRow">
                  <i class="el-icon-plus"></i>
                  新增
                </el-button>
              </el-col>
            </el-row>
            <vxe-table
              style="margin-top: 0px; height: 80%"
              :stripe="true"
              ref="vxeTable"
              height="390"
              :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
              :row-config="{height: 30,isHover: true,padding: 0,}"
              :row-style="{ fontSize: '12px',  }"
              show-overflow
              :column-config="{ resizable: true }"
              :loading="loading"
              :edit-config="{trigger: 'manual', mode: 'row', showStatus: true, autoClear: false}"
              :data="dataList">

              <vxe-column field="changeDate" title="技改日期" width="200" :edit-render="{}">
                <template #edit="{row}" style="width: 100%;">
                  <el-date-picker
                    style="width: 100%; margin: 0"
                    v-model="row.changeDate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </template>
              </vxe-column>
              <vxe-column field="changeType"
                          title="技改类型"
                          :edit-render="{name: 'select', options:[{ value:1, label:'新旧通用' }, { value:2, label:'互不通用' }, { value:3, label:'新通用旧' }, { value:4, label:'旧通用新' }, { value:5, label:'弃旧用新' }]}"
                          width="130">
                <template #edit="{row}" style="width: 100px;">
                  <el-select v-model="row.changeType" placeholder="请选择" size="mini">
                    <el-option :key="1" label="新旧通用" :value="1"></el-option>
                    <el-option :key="2" label="互不通用" :value="2"></el-option>
                    <el-option :key="3" label="新通用旧" :value="3"></el-option>
                    <el-option :key="4" label="旧通用新" :value="4"></el-option>
                    <el-option :key="5" label="弃旧用新" :value="5"></el-option>
                  </el-select>
                </template>
              </vxe-column>
              <vxe-column field="changePartsCode" title="技改后配件编码" :edit-render="{}" width="160">
                <template #edit="{row}">
                  <el-input size="small"
                            :readonly="true"
                            @focus="changeParts(row)"
                            v-model="row.changePartsCode">
                    <i slot="suffix" class="el-icon-more" @click="changeParts(row)"></i>
                  </el-input>
                </template>
              </vxe-column>
              <vxe-column field="changePartsName" title="技改后配件描述" width="160"></vxe-column>
              <vxe-column field="changeRemark" title="技改说明" :edit-render="{}" width="">
                <template #edit="{row}" style="width: 100%;" >
                  <el-input size="small"
                            v-model="row.changeRemark">
                  </el-input>
                </template>
              </vxe-column>
              <vxe-column title="操作" width="80" v-if="bom_change_edit">
                <template #default="{ row }">
                  <template v-if="$refs.vxeTable.isActiveByRow(row)">
                    <a href="javascript:void(0);" class="a-link" @click=saveRowEvent(row);>
                      <el-tooltip :enterable="false" effect="dark" content="保存" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-circle-check"/>
                      </el-tooltip>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;
                  </template>
                  <template v-else>
                    <a href="javascript:void(0);" class="a-link" @click=editRowEvent(row);>
                      <el-tooltip :enterable="false" effect="dark" content="编辑" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="javascript:void(0);" class="a-link" @click=deleteRow(row);>
                      <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-delete"/>
                      </el-tooltip>
                    </a>
                  </template>
                  <a v-if="!row.id" href="javascript:void(0);" class="a-link" @click=deleteRow(row);>
                    <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-delete"/>
                    </el-tooltip>
                  </a>
                </template>
              </vxe-column>
            </vxe-table>
          </div>
        </div>
      </div>
    </template>

    <!--    <span slot="footer" class="dialog-footer">-->

    <!--			<el-button type="primary" plain class="button-sty" @click="dialogClose">-->
    <!--				<i class="el-icon-close el-icon"></i>-->
    <!--				取 消-->
    <!--			</el-button>-->
    <!--			<el-button type="primary" @click="dialogPrimary" class="button-sty">-->
    <!--				<i class="el-icon-check el-icon"></i>-->
    <!--				确 定-->
    <!--			</el-button>-->
    <!--		</span>-->

    <radioPartsDialog v-if="showPartsPop"
                      :visiable.sync="showPartsPop"
                      @commitSelectedRow="data => {
                        currentRowData.partsId = data.id;
                        currentRowData.changePartsCode = data.partsCode;
                        currentRowData.changePartsName = data.partsName;
                      }"
    />

  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import radioPartsDialog from "@/views/dialogCommon/radioPartsDialog.vue";
import {mapGetters} from "vuex";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'bomId'],
  mixins: [selectDialogMixins],
  components: {radioPartsDialog, pager},

  created() {
    this.initSetting();
    this.formData.bomId = this.bomId
    this.bom_change_edit = this.permissions['bom_change_edit']
  },
  mounted() {
    this.loadData()
  },
  computed: {
  ...mapGetters(["permissions"])
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      bom_change_edit: false,

      loading: false,
      currentRowData: null,
      showPartsPop: false,
      getTableDataUrl: '/basic/basParts/getReplacePartsList',
      total: 0,
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        bomId: null,
      },
      formData1: {
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',
      selectedRow: {
        id: '', name: ''
      },
      checkedArray: [],
      columns: [
        // { type: "checkbox", width: 40, fixed: 'left' },
        {title: '技改日期', field: 'changeDate', width: 150,},
        {title: '技改类型', field: 'changeType', width: 150, slots: {default: 'changeTypeSlots'}},
        {title: '技改后配件编码', field: 'changePartsCode', width: 150,},
        {title: '技改后配件描述', field: 'changePartsName', width: 150,},
        {title: '技改说明', field: 'changeRemark', width: 150,},
      ],
      dataList: [],
      updateData: {},
      isEdit: false,
    };
  },


  methods: {
    async addRow() {
      if (this.isEdit) {
        this.$message.error('请先保存当前正在编辑的数据')
        return
      }
      this.isEdit = true

      console.log('add row')
      const $table = this.$refs.vxeTable
      let record = {
        changeType: null,
        changePartsCode: null,
        changePartsName: null,
        changeRemark: null,
        bomId: this.bomId,
        partsId: null,
        id: null
      }
      const { row: newRow } = await $table.insertAt(record, -1)
      await $table.setActiveRow(newRow)
    },

    deleteRow(row) {
      console.log('delete row', row)
      if (!row.id) {
        this.$refs.vxeTable.remove(row)
        this.isEdit = false
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.$mask.open()
          this.$http.post(api.basPartsBomChange.delete, {id: row.id}).then(res => {
            this.$message.success('操作成功')
            this.$mask.close()
            this.$refs.vxeTable.remove(row)
          })
        })
      }
    },

    editRowEvent(row) {
      if (this.isEdit) {
        this.$message.error('请先保存当前正在编辑的数据')
        return
      }
      this.isEdit = true
      const $grid = this.$refs.vxeTable
      $grid.setActiveRow(row)
    },

    saveRowEvent(row) {
      console.log('saveRow', row)
      if (!row.partsId) {
        this.$message.error('请绑定配件数据')
        return
      }

      if (!row.changeType) {
        this.$message.error('请选择类型')
        return
      }

      if (!row.changeDate) {
        this.$message.error("请选择日期")
        return;
      }

      const $grid = this.$refs.vxeTable
      $grid.clearActived().then(() => {
        // this.loading = true
        this.updateData.id = row.id
        this.updateData.changeType = row.changeType
        this.updateData.changePartsCode = row.changePartsCode
        this.updateData.changePartsName = row.changePartsName
        this.updateData.changeRemark = row.changeRemark
        this.updateData.bomId = row.bomId
        this.updateData.partsId = row.partsId
        this.updateData.changeDate = row.changeDate

        this.updateDataCommit()
      })
    },

    updateDataCommit() {
      this.$http({
        url: this.updateData.id ? api.basPartsBomChange.update : api.basPartsBomChange.add,
        method: 'post',
        data: this.updateData
      }).then(res => {
        this.$message.success('操作成功')
        // this.loading = false
        this.isEdit = false

        this.loadData()
      })
    },



    changeParts(row) {
      console.log('changeParts', row)
      this.currentRowData = row
      this.showPartsPop = true
    },


    loadData() {
      this.$mask.open()
      this.$http.post(api.basPartsBomChange.getList, {bomId: this.bomId}).then(res => {
        this.dataList = res.data.data
        this.$mask.close()
      })
    },


    flushed() {
      this.checkedArray = []
      this.$refs['table-m1'].commitProxy('reload');
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 搜索
    searchEvent() {
      this.formData.partsCode = this.formData1.partsCode
      this.formData.partsName = this.formData1.partsName
      this.formData.partsSpec = this.formData1.partsSpec
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    // // 保持
    //   saveDialog(){
    //     const  $grid = this.$refs.table;
    //     console.log($grid,"选中的值");
    //     const rows = $grid.getCheckboxReserveRecords(true);
    //     $grid.clearCheckboxRow();
    //     console.log(rows,"选中的值");
    //     console.log("点击确认！！")
    //     this.$emit("confirm", rows.map(item => item.id),this.changeObj);
    //     // this.showDialog = false;
    //   },

    // 重置
    resetEvent() {
      this.formData.searchCount = false
      this.formData.current = 1
      this.formData.partsCode = ''
      this.formData.partsName = ''
      this.formData.partsSpec = ''
      this.formData.bigCategoryId = ''
      this.formData.smallCategoryId = ''
      console.log('request', this.requestParam)
      this.formData1 = {
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
      }
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.reloadTree()
    },


    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },


    reloadTree() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    // 点击的树形 点
    handleNodeClick(node, data) {
      let id = data.data.id;
      if (data.level === 1) {
        this.formData.bigCategoryId = id;
        this.formData.smallCategoryId = '';
      } else {
        this.formData.smallCategoryId = id;
      }

      this.initTableList();
      this.flushed()
    },

    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.basPartsBomChange.getPage,
        param: this.formData,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption)
      this.flushed()
    },


    // 加载页面
    loadChildNode(node, resolve) {
      fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        resolve(
          data.data.map(item => {
            return {
              label: item.categoryName,
              id: item.id,
              leaf: Number(item.isChild) == 1 ? false : true,
            }
          })
        )
      });
    },

  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep body .dialog-style.list-dialog .el-dialog__body {
  background: #F1F5FB;
  padding: 8px 0px 1px !important;
  height: 575px;
}

// ::v-deep .grid-height {
// 	height: calc(100vh - 270px) !important;
// }
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -40px !important;
  position: absolute !important;
  z-index: 9;
  background-color: #ffffff;
}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}
</style>
